import React, { useContext } from 'react';
import styles from "../Settings.module.css";
import GuiContext from 'config/context/guiContext';

const DocsSettings = () => {
    const {
        URL,
    } = useContext(GuiContext);
    return (
        <div className={styles.docsSettings}>
            <div className={styles.settingsContainer}>
                <a target="_blank" rel="noreferrer" href={`${URL}/api/docs/`}>API Documentation</a>
            </div>
        </div>
    )
}

export default DocsSettings;